module.exports = __webpack_public_path__ + "img/attorney_auth.93c22466.svg";